import React from 'react';

/**
 * Displayed at the top of the page when the backend returns HTTP 503,
 * indicating that the database is temporarily unreachable.
 */
export default function ServiceUnavailableBanner({ onDismiss }) {
  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 flex items-center justify-between shadow-lg"
    >
      <div className="flex items-center gap-3">
        <span className="text-xl flex-shrink-0" aria-hidden="true">⚠️</span>
        <div>
          <p className="font-semibold text-sm leading-tight">
            Layanan Tidak Tersedia
          </p>
          <p className="text-xs text-red-100 mt-0.5">
            Database sedang tidak dapat dijangkau. Beberapa fitur mungkin tidak
            berfungsi. Mohon coba beberapa saat lagi.
          </p>
        </div>
      </div>
      <button
        onClick={onDismiss}
        className="ml-4 flex-shrink-0 text-white/80 hover:text-white text-lg font-bold leading-none transition-colors"
        aria-label="Tutup notifikasi"
      >
        ✕
      </button>
    </div>
  );
}
